import React from "react";

import { makeStyles } from "@material-ui/core";
import PropTypes from "prop-types";

import RbFlexTableHeadContext from "components/RbFlexTableHead/RbFlexTableHeadContext";

const useStyles = makeStyles(() => ({
  root: (props) => ({
    boxSizing: "border-box",
    flex: props.flex,
    overflowWrap: "anywhere",
    minWidth: 1,
    padding: 8,
    textAlign: props.align,
  }),
}));

const RbFlexTableCell = React.forwardRef(function RbFlexTableCell(props, ref) {
  const { children, flex, align, ...other } = props;

  const classes = useStyles(props);

  const headContext = React.useContext(RbFlexTableHeadContext);

  const role = headContext ? "columnheader" : "cell";

  return (
    <div role={role} {...other} ref={ref} className={classes.root}>
      {children}
    </div>
  );
});

RbFlexTableCell.propTypes = {
  children: PropTypes.node,
  flex: PropTypes.string,
  align: PropTypes.oneOf(["left", "center", "right"]),
};

RbFlexTableCell.defaultProps = {
  children: null,
  flex: "1",
  align: undefined,
};

export default React.memo(RbFlexTableCell);
